// import { useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import Icon from "../Icon";
import { useIntl } from 'react-intl';

const Header = ({ categor, theme, toogleMode, mode }) => {
  const intl = useIntl();

  // const [menuHover, setMenuHover] = useState(null);
  // const mouseOut = (element) => {
  //   if (menuHover === element) {
  //     setMenuHover(null);
  //   }
  // }
//onClick={() => setOpenMenu(!openMenu)}
  return (<Navbar>
    <Container fluid>
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
          <Link to="/" className="home-button" title={intl.formatMessage({ id: 'home_page.link_title', defaultMessage: 'Nyitólap - további helyzetképek' })} ><Icon icon="home" className={"white"} /></Link>
          <Nav.Link className={`publication-title ${mode!=="dark"? "" : "theme-color"}`}>{theme && theme.title}</Nav.Link>
        </Nav>
      </Navbar.Collapse>
      <div className="mode-toogle-icon"  title={mode&&mode==="dark"?"Light mode":"Dark mode"}  onClick={toogleMode} >
          {mode&&mode==="dark"&&<Icon icon={"sun"} className={"white"} ></Icon>}
          {mode&&mode!=="dark"&&<Icon icon={"moon"}  className={"white"} ></Icon>}
          </div>
      <Navbar.Brand href={"https://ksh.hu?lang=" + intl.locale}  >
        <img src={intl.formatMessage({ id: 'hcso_logo_circle.url', defaultMessage: 'assets/ksh-logo-circle.svg' })} alt={intl.formatMessage({ id: 'hcso_logo_circle.alt', defaultMessage: 'KSH logo' })} height="30" className={`icon white d-sm-none d-inline-block align-top icon`} />
        <img src={intl.formatMessage({ id: 'hcso_logo.url', defaultMessage: 'assets/ksh-logo.svg' })} alt={intl.formatMessage({ id: 'hcso_logo.alt', defaultMessage: 'KSH logo' })} height="30" className={`icon white d-none d-sm-block d-inline-block align-top icon`} />
        </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
    </Container>
  </Navbar>)
}

export default Header;
